import Vue from 'vue'
import Router from 'vue-router'
import CalendarView from '@/View/CalendarView'
import EventView from '@/View/EventView'

Vue.config.productionTip = false

Vue.use(Router)

export const router = new Router({
  routes: [
    {
      path: '/',
      redirect: { name: 'CalendarView' }
    },
    {
      name: 'CalendarView',
      path: '/calendar',
      component: CalendarView,
      props: true
    },
    {
      name: 'EventView',
      path: '/event/:id(\\d+)',
      component: EventView,
      props: true
    }
  ],
  scrollBehavior (to, from, savedPos) {
    if (savedPos) {
      return savedPos
    } else {
      return { x: 0, y: 0 }
    }
  }  
})
